"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntityLocking = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const prompt_context_1 = require("../prompt/prompt-context");
const prompt_register_hook_1 = require("../prompt/prompt-register-hook");
const user_context_1 = require("../../providers/user/user-context");
const web_socket_context_1 = require("../../providers/web-socket/web-socket-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const detail_types_1 = require("./detail-types");
const TIMEOUT_PROMPT_KEY = 'TIMEOUT';
const EXPIRATION_PROMPT_KEY = 'EXPIRATION';
const FORCE_RELEASE_PROMPT_KEY = 'FORCE_UNLOCK';
function useEntityLocking({ enabled, source, entityName, mode, setMode, forceReleasePermission, }) {
    var _a;
    const { subscribe, unsubscribe, client } = (0, react_1.useContext)(web_socket_context_1.WebsocketContext);
    const { user, hasPermission } = (0, react_1.useContext)(user_context_1.UserContext);
    const { testPrompt } = (0, react_1.useContext)(prompt_context_1.PromptContext);
    const [expiration, setExpiration] = (0, react_1.useState)(undefined);
    const [lockedByUser, setLockedByUser] = (0, react_1.useState)(undefined);
    const id = (_a = source.data) === null || _a === void 0 ? void 0 : _a.id;
    const handleLock = (0, event_callback_hook_1.useEventCallback)((res) => {
        var _a;
        const response = JSON.parse(res.body);
        if (lockedByUser !== undefined && (response === null || response === void 0 ? void 0 : response.released)) {
            if (mode === detail_types_1.DetailMode.VIEW) {
                source.refresh();
            }
        }
        if (mode === detail_types_1.DetailMode.EDIT &&
            (response === null || response === void 0 ? void 0 : response.released) &&
            (lockedByUser === null || lockedByUser === void 0 ? void 0 : lockedByUser.id) === (user === null || user === void 0 ? void 0 : user.id)) {
            setMode(detail_types_1.DetailMode.VIEW);
            source.refresh();
            testPrompt({
                key: TIMEOUT_PROMPT_KEY,
                submitCallback: lodash_1.noop,
            });
        }
        setExpiration((_a = response.expiration) !== null && _a !== void 0 ? _a : undefined);
        setLockedByUser((response === null || response === void 0 ? void 0 : response.userId)
            ? { id: response.userId, name: response.userName }
            : undefined);
    });
    const remindExpiration = (0, event_callback_hook_1.useEventCallback)(() => {
        testPrompt({
            key: EXPIRATION_PROMPT_KEY,
            submitCallback: keepLockAlive,
        });
    });
    const acquireLock = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        if (enabled && client && lockedByUser === undefined) {
            (_a = client.current) === null || _a === void 0 ? void 0 : _a.publish({
                destination: `/app/lock/${entityName}/${id}/acquire`,
            });
        }
    });
    const releaseLock = (0, event_callback_hook_1.useEventCallback)((force) => {
        var _a;
        if (enabled && client && ((lockedByUser === null || lockedByUser === void 0 ? void 0 : lockedByUser.id) === (user === null || user === void 0 ? void 0 : user.id) || force)) {
            (_a = client.current) === null || _a === void 0 ? void 0 : _a.publish({
                destination: `/app/lock/${entityName}/${id}/release${force ? '/force' : ''}`,
            });
        }
    });
    const checkLock = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        if (enabled && client && id !== undefined) {
            (_a = client.current) === null || _a === void 0 ? void 0 : _a.publish({
                destination: `/app/lock/${entityName}/${id}/check`,
            });
        }
    });
    const keepLockAlive = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        if (enabled && client && lockedByUser !== undefined) {
            (_a = client.current) === null || _a === void 0 ? void 0 : _a.publish({
                destination: `/app/lock/${entityName}/${id}/keep-alive`,
            });
        }
    });
    const forceReleaseLock = (0, event_callback_hook_1.useEventCallback)(() => {
        testPrompt({
            key: FORCE_RELEASE_PROMPT_KEY,
            submitCallback: () => releaseLock(true),
        });
    });
    (0, react_1.useEffect)(() => {
        const handleTabClose = () => {
            if ((lockedByUser === null || lockedByUser === void 0 ? void 0 : lockedByUser.id) === (user === null || user === void 0 ? void 0 : user.id)) {
                releaseLock();
            }
        };
        window.addEventListener('beforeunload', handleTabClose);
        return () => {
            window.removeEventListener('beforeunload', handleTabClose);
        };
    }, [lockedByUser, user === null || user === void 0 ? void 0 : user.id, releaseLock]);
    (0, react_1.useEffect)(() => {
        const queueLockSubscription = enabled && id !== undefined && entityName
            ? subscribe(`/user/queue/lock/${entityName}/${id}`, handleLock)
            : undefined;
        const topicLockSubscription = enabled && id !== undefined && entityName
            ? subscribe(`/topic/lock/${entityName}/${id}`, handleLock)
            : undefined;
        checkLock();
        return () => {
            if (queueLockSubscription !== undefined) {
                unsubscribe(queueLockSubscription);
            }
            if (topicLockSubscription !== undefined) {
                unsubscribe(topicLockSubscription);
            }
        };
    }, [enabled, id, subscribe, unsubscribe, entityName, handleLock, checkLock]);
    (0, prompt_register_hook_1.usePrompts)([
        {
            key: TIMEOUT_PROMPT_KEY,
            dialogTitle: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__TIMEOUT__TITLE", defaultMessage: "Varov\u00E1n\u00ED" })),
            dialogText: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__TIMEOUT__TEXT", defaultMessage: "\u010Cas pro editaci z\u00E1znamu vypr\u0161el." })),
            dialogShowConfirm: false,
        },
        {
            key: EXPIRATION_PROMPT_KEY,
            dialogTitle: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__EXPIRATION__TITLE", defaultMessage: "Varov\u00E1n\u00ED" })),
            dialogText: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__EXPIRATION__TEXT", defaultMessage: "\u010Cas pro editaci z\u00E1znamu t\u00E9m\u011B\u0159 vypr\u0161el. P\u0159ejete si jej prodlou\u017Eit a pokra\u010Dovat v editaci?" })),
        },
        {
            key: FORCE_RELEASE_PROMPT_KEY,
            dialogTitle: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__FORCE_UNLOCK__TITLE", defaultMessage: "Odemknut\u00ED z\u00E1znamu" })),
            dialogText: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__FORCE_UNLOCK__TEXT", defaultMessage: "Z\u00E1znam je aktu\u00E1ln\u011B editov\u00E1n jin\u00FDm u\u017Eivatelem, opravdu si p\u0159ejete editaci ukon\u010Dit a z\u00E1znam odemknout? Tato akce je nevratn\u00E1, rozpracovan\u00E9 zm\u011Bny nebudou ulo\u017Eeny." })),
        },
    ], []);
    return {
        acquireLock,
        releaseLock,
        keepLockAlive,
        remindExpiration,
        lockedByUser,
        expiration,
        forceReleaseLock: forceReleasePermission && hasPermission(forceReleasePermission)
            ? forceReleaseLock
            : undefined,
    };
}
exports.useEntityLocking = useEntityLocking;
//# sourceMappingURL=entity-locking-hook.js.map